export const DIRECTORY_CATEGORIES = ['organic', 'tap', 'organic_branch'];
export const DIRECTORY_CATEGORY_LABELS = {
    organic: '有機',
    tap: '產銷履歷',
    organic_branch: '有機加分流',
};
export const DIRECTORY_STATUSES = ['active', 'suspended', 'terminated', 'archived'];
export const DIRECTORY_STATUS_LABELS = {
    active: '有效',
    suspended: '暫停',
    terminated: '已終止',
    archived: '已歸檔',
};
/**
 * 從 verificationScheme 推導預設 category。
 * 回 null 表示無法推導，需由呼叫方提供 category 或跳過 sync。
 */
export function mapSchemeToCategory(scheme) {
    if (!scheme)
        return null;
    if (scheme === 'TAP')
        return 'tap';
    if (scheme === 'TOP' || scheme === 'ECO')
        return 'organic';
    return null;
}
